import { makeDataSample, makeMilestoneListSample } from "./index.preview";
import { debounce } from "lodash";
import { debuglog } from "../utility/debuglog";

let isLongText = false;
let oldData = {}

export default [
  {
    name: 'add-tip',
    class: 'btn-add-tip',
    label: 'Add tip',
    exec: (manager) => {
      const amount = Math.floor(Math.random() * 50000);
      debuglog(`New tip 💰 ${h.formatPrice(amount)}`);
      setDefaultSetting(manager)
      updateGoalProgressSimulation(manager, amount);
    }
  },
  {
    name: 'Reset Progress',
    class: 'btn-reset-progress',
    label: 'Reset Progress',
    exec: (manager) => {
      debuglog(`Reset progress`)
      setDefaultSetting(manager)
      manager.updateReceived(0);
    }
  },
  {
    name: 'Reload',
    class: 'btn-reload-data',
    label: 'Reload',
    exec: (manager) => {
      debuglog(`Reload data`)
      setDefaultSetting(manager)
      manager.loadData();
    }
  },
  {
    name: 'Randomize',
    class: 'btn-randomize',
    label: 'Randomize',
    exec: (manager) => {
      debuglog(`Randomize data`)
      setDefaultSetting(manager)
      manager.reload(false, makeDataSample());
    }
  },
  {
    name: 'Simulation',
    class: 'btn-reload-simulation',
    label: 'Simulation',
    exec: (manager) => {
      setDefaultSetting(manager)
      const times = [500, 1100, 1200, 2000, 3000, 3200, 3600, 4000, 4200, 6100, 6200, 7400, 7700, 8900];
      let simulationRIS = 0;

      // simulation running in seconds

      setInterval(() => {
        // manager.widget.simulationRIS += 100
        simulationRIS += 100
      }, 100)

      times.forEach((data) => {
        setTimeout(() => {
          reloadSimulation();
        }, data);
      });

      function reloadSimulation() {
        const amount = Math.floor(Math.random() * 100000);
        debuglog(`[${simulationRIS}ms] New tip 💰 ${h.formatPrice(amount)}`);

        reloadHandlerSimulation(simulationRIS, amount);
      }

      let reloadHandlerSimulation = debounce((ms, amount) => {
        debuglog(`[${simulationRIS}ms] Reload data from [${ms}ms]`);

        updateGoalProgressSimulation(manager, amount);
      }, 500, { 'maxWait': 1000 });
    }
  },
  {
    name: 'LongText',
    class: 'btn-debug-longtext',
    label: 'Long Text',
    exec: (manager) => {
      isLongText = true
      let text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."

      let templist = [
        { "target": 999999, "description": "Loremipsumdolorsitametconsecteturadipiscingelitseddoeiusmodtemporincididuntutlaboreetdoloremagnaaliqua"},
        { "target": 999999999, "description": text},
        { "target": 999999999999, "description": text},
        { "target": 999999999999999, "description": text},
      ];

      oldData = h.cloneProp(manager.widget.data);
      let tempData = h.cloneProp(manager.widget.data);
      tempData.targetReceived = 999999999
      tempData.url = "trakteer.id/Loremipsumdolorsitametconsecteturadipiscingelitseddoeiusmodtemporincididuntutlaboreetdoloremagnaaliqua"
      manager.updateMilestoneListAndRemainingPreview(templist, tempData)
      manager.widget.setting['ms_title'] = text
      manager.reload(false, tempData);

      debuglog(`Check Long text input`);
    }
  },
  {
    name: 'emptyState',
    class: 'btn-debug-emptystate',
    label: 'Empty State',
    exec: (manager) => {
      setDefaultSetting(manager)
      let emptyList = [];
      let tempData = h.cloneProp(manager.widget.data);
      tempData.targetReceived = 0;
      manager.updateMilestoneListAndRemainingPreview(emptyList, tempData)
      manager.reload(false, tempData);
      debuglog("Reset empty state")
    }
  },
];

function updateGoalProgressSimulation(manager, amount) {
  const tempData = h.cloneProp(manager.widget.data);

  const targetReceived = parseInt(tempData.targetReceived);
  const newTargetReceived = targetReceived + amount;
  manager.updateReceived(newTargetReceived);
}

async function setDefaultSetting(manager) {
  if(isLongText) {
    isLongText = false;
    manager.widget.setting['ms_title'] = h.args('ms_title') || "Milestone Bulan Ini"
    let listMilestone = (String(h.args('use_placeholder')).toLowerCase() === 'true')? makeMilestoneListSample() : await manager.loadMilestoneData()
    const tempData = oldData;
    manager.updateMilestoneListAndRemainingPreview(listMilestone, tempData)
    manager.reload(false, tempData);
  }
}